document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('size-calculator-form');
    const tokenElement = document.getElementById('starcue-token');

    const accessToken = tokenElement ? tokenElement.dataset.token : null;

    if (!accessToken) {
        console.error('API Token not found. Please check your Snippet configuration.');
        return;
    }

    if (form) {
        form.addEventListener('submit', function (event) {
            event.preventDefault();

            const length = parseFloat(document.getElementById('length').value.replace(',', '.'));
            const width = parseFloat(document.getElementById('width').value.replace(',', '.'));

            if (isNaN(length) || isNaN(width) || length <= 0 || width <= 0) {
                document.getElementById('size-result').textContent = 'Bitte gib gültige positive Werte ein.';
                return;
            }

            fetch(`https://starcue-daedalus.de/starcue_technology/calculate-starcue-size/?length=${length}&width=${width}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Token ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            })
            .then(response => {
                if (!response.ok) {
                    if (response.status === 401) {
                        throw new Error('Unauthenticated: Bitte überprüfe deinen Token.');
                    }
                    throw new Error(`Fehler: ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                const size = data.size;
                saveStarCueSize(size); // Save size to localStorage
                updateStarCueSize(); // Update the banner with the new size
                const resultElement = document.getElementById('size-result');
                resultElement.textContent = `${size}`;
                resultElement.classList.add('fade-in');
            })
            .catch(error => {
                console.error('API-Fehler:', error);
                document.getElementById('size-result').textContent = 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.';
            });
        });
    }
});

/**
 * Saves the calculated size to localStorage
 * @param {string} size - The calculated size
 */
function saveStarCueSize(size) {
    localStorage.setItem('starcueSize', size);
}

/**
 * Updates the banner with the current size from localStorage
 */
function updateStarCueSize() {
    const sizeValueElement = document.getElementById('starcue-size-value');

    if (!sizeValueElement) {
        console.error('Element "#starcue-size-value" not found!');
        return;
    }

    const savedSize = localStorage.getItem('starcueSize');
    sizeValueElement.textContent = savedSize || 'Noch nicht berechnet.';
}